import l from '../lang';

export default {
	'routes': {
		'create': 'contacts.create',
		'show': 'contacts.show',
		'index': 'contacts.index',
	},
	'delete-single': l.t('contacts.delete-single', 'Are you sure you want to delete this contact?'),
	'delete-filtered': l.t('contacts.delete-filtered', 'Are you sure you want to delete all filtered contacts?'),
	'delete-all': l.t('contacts.delete-all', 'Are you sure you want to delete all contacts?'),
	'successfull-creation': l.t('contacts.successfully-created', 'Your contact has been added'),
	'successfull-update': l.t('app.successful-update', 'Your changes have been saved'),
	'failed-creation': l.t('contacts.failed-creation', 'There was a problem creating your contact'),
	'failed-update': l.t('app.update-error', 'An error occurred while attempting to save your changes. Please try again.'),
	'currently-in-use': l.t('contacts.this-contact-is-currently-in-use', 'This contact is currently in use'),
	'to-delete-used': l.t('contacts.to-delete-this-contact-remove-it', 'To delete this contact, remove it from your call handling rules first, then try again.'),
};
